import { render, staticRenderFns } from "./nice-radio.vue?vue&type=template&id=24b8c780&scoped=true"
import script from "./nice-radio.vue?vue&type=script&lang=js"
export * from "./nice-radio.vue?vue&type=script&lang=js"
import style0 from "./nice-radio.vue?vue&type=style&index=0&id=24b8c780&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8c780",
  null
  
)

export default component.exports